module.exports = __webpack_public_path__ + "static/img/gzh3.2b5e583.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gzh3.jpg
// module id = CNHz
// module chunks = 1